import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import CalendarComp from "./components/campus/calendarComp"
import Intro from "./components/popup/intro"
import {isIE} from 'react-device-detect';
// import {isIE, isMobile} from 'react-device-detect';

export default class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (isIE) 
      return(
      <div className="loading"> IE is not supported. Download Chrome/Firefox/Microsoft Edge </div>
    ) 

    // if (isMobile) {
    //   window.location.href = "https://m-meeting.k8s.bns.co.kr";
    //   return null;
    // }

    return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/campus/reservation" component={CalendarComp}></Route>
          <Route exact path="/" component={CalendarComp}></Route>
          <Route exact path="/intro" component={Intro}></Route>
        </Switch>
      </BrowserRouter>
    );
  }
}
